<template>
  <span class="fx hll-radio-box" @click="$emit('click')">
    <span class="hll-radio-temp" :class="{ selected: checked }"></span>
  </span>
</template>

<script>
/**
 * 使用方法：
 * <radio name="groupName" :checked="isChecked" @click="handleCheck"/>
 * api:
 * checked: 是否选中
 * @click: 点击冒泡
 * 后续可以加上disable属性，目前ui没有故没加
 */
export default {
  name: 'radio',
  props: ['checked'],
};
</script>

<style lang="less" scoped>
.bc-input {
  display: none;
}
.hll-radio-box {
  width: 20px;
  height: 20px;
  padding: 2px 0;
  display: inline-block;
}
.hll-radio-temp {
  display: inline-block;
  background-color: transparent;
  border-radius: 50%;
  border: 1px solid rgba(0, 0, 0, 0.25);
  position: relative;
  width: 18px;
  height: 18px;
  &:after {
    content: ' ';
    border-radius: 100%;
    position: absolute;
    /*transition: transform .2s;*/
    transform: scale(0);
    width: 18px;
    height: 18px;
    border: 4px solid #ffffff;
    box-sizing: border-box;
  }
}

.hll-radio-temp.selected {
  background-color: #f16622;
  border-color: #f16622;
  &:after {
    transform: scale(1);
  }
}
</style>
